import { Injectable } from '@angular/core';
import { HarmonizedCommodityLookupModel } from 'app/generated/backend/trade/api/harmonized-commodity-lookup-model';
import { HarmonizedCommodityLookupHandlerService } from 'app/generated/backend/trade/service/harmonized-commodity-lookup-handler';
import { CoreCacheService } from '../cache/CoreCacheService';
import { CachedEntityService } from 'app/_templates/CachedEntityService';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class CoreHarmonizedCommodityLookupService extends CachedEntityService<HarmonizedCommodityLookupModel> {
	constructor(
		currenciesHandlerService: HarmonizedCommodityLookupHandlerService,
		cacheService: CoreCacheService
	) {
		super(currenciesHandlerService, cacheService.getHarmonizedCommodities());
	}

	nameByCode: Map<string, string>;
	getNameByCode(code: string): Observable<string> {

		if (this.nameByCode) {
			return of(this.nameByCode.get(code));
		}
		return this.service.get().pipe(map(response => {
			this.nameByCode = new Map<string, string>();
			response.data.forEach(item => {
				this.nameByCode.set(item.code, item.name);
			});
			return this.nameByCode.get(code);
		}));
	}
	transformItem(item: HarmonizedCommodityLookupModel): HarmonizedCommodityLookupModel {
		if (item) {
			item.match = '';
			if (item.code) {
				item.match += item.code.toLowerCase();
			}
			if (item.name) {
				item.match += ' ' + item.name.toLowerCase();
			}
		}
		return item;
	}
}
